var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ValidationObserver', {
    ref: "observerRef"
  }, [_vm._t("default", null, {
    "formValidationError": _vm.formValidationError,
    "onDataChange": _vm.onDataChange,
    "newOrder": _vm.newOrder,
    "activeIds": _vm.activeIds,
    "toggleActive": _vm.toggleActive,
    "setActiveList": _vm.setActiveList,
    "validate": _vm.validate,
    "scrollTo": _vm.scrollTo,
    "onLoad": _vm.onSuccess,
    "onComplete": _vm.onComplete,
    "isAllAvailableProductActive": _vm.isAllAvailableProductActive,
    "isAvailableBonusesPay": _vm.isAvailableBonusesPay,
    "avilableProductIDList": _vm.avilableProductIDList,
    "isPrivacyPolicyChecked": _vm.isPrivacyPolicyChecked,
    "isShowCallbackCheckbox": _vm.isShowCallbackCheckbox,
    "setPrivacyPolicy": _vm.setPrivacyPolicy,
    "isPreOrder": _vm.isPreOrder
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }